// Сколько пользователей должно быть на странице
export const USERS_LENGTH_IN_PAGE = 25
